import { useState } from 'react';
import CopyToClipboardButton from '@rossum/components/copy-to-clipboard/CopyToClipboardButton';
import DocumentFileName from '@rossum/components/filename/DocumentFileName';
import { Box, Stack } from '@rossum/ui/material';

type FilenameProps = {
  originalFileName: string | null | undefined;
  disabled: boolean;
  status: string;
  estimatedFilenameLength?: number;
  disableClipboard?: boolean;
};

const Filename = ({
  originalFileName,
  disabled,
  status,
  estimatedFilenameLength,
  disableClipboard,
}: FilenameProps) => {
  const [isHovered, setIsHovered] = useState(false);

  return originalFileName ? (
    <Stack
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      flexDirection="row"
      alignItems="center"
      gap={0.5}
      data-cy="file-name"
      sx={{
        maxWidth: 1,
        ...(disabled && (status === 'failed_import' || status === 'importing')
          ? {
              color: 'text.disabled',
              cursor: status === 'importing' ? 'wait' : 'not-allowed',
              textDecoration: 'none',
            }
          : {}),
      }}
    >
      <Box
        component="div"
        sx={{
          fontSize: 'inherit',
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          whiteSpace: 'nowrap',
          maxWidth: estimatedFilenameLength ?? '100%',
        }}
      >
        {originalFileName}
      </Box>
      {!disableClipboard && isHovered ? (
        <div>
          <CopyToClipboardButton
            content={originalFileName}
            iconColor="action"
          />
        </div>
      ) : null}
    </Stack>
  ) : (
    <DocumentFileName originalFileName={originalFileName} />
  );
};

export { Filename };
